import { AxiosError } from 'axios';

export function extractErrorMessage(err: unknown): string {
  if (err instanceof AxiosError) {
    const data = err.response?.data as { message?: string } | undefined;
    if (data?.message) return data.message;
    return err.message || 'Erreur réseau';
  }
  if (err instanceof Error) return err.message;
  return 'Erreur inattendue';
}
